import {
  CREATEPRODUCTDESIGNATION,
  GETPRODUCTDESIGNATION,
  UPDATEPRODUCTDESIGNATION,
  DELETEPRODUCTDESIGNATION,
} from "../actions/types";

const initialState = {
  productDesignationList: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GETPRODUCTDESIGNATION:
      return { ...state, productDesignationList: action.payload.data };
    case CREATEPRODUCTDESIGNATION:
      return { ...state, productDesignationSaveStatus: action.payload.success };
    case UPDATEPRODUCTDESIGNATION:
      return {
        ...state,
        productDesignationUpdateStatus: action.payload.success,
      };
    case DELETEPRODUCTDESIGNATION:
      return {
        ...state,
        productDesignationList: state.productDesignationList.filter(
          (item) => item.id !== action.designationId,
        ),
        productDesignationDeleteStatus: action.payload.success,
      };
    default:
      return state;
  }
}
